export default __webpack_public_path__ + "static/media/mask-detail.a8fb6774.svg";